var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.504,
    height: 36.771,
    viewBox: "0 0 34.504 36.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2079",
    x: 0,
    y: 0,
    width: 34.504,
    height: 36.771,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3b4558",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "triangle",
    transform: "translate(27.502 5.347) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2746",
    "data-name": "Group 2746",
    transform: "translate(1.552 2.897)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0, -1, 1, 0, -6.9, 24.6)",
    filter: "url(#Path_2079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2079-2",
    "data-name": "Path 2079",
    d: "M10.039,2A2.539,2.539,0,0,1,12.2,3.213l0,0L19.08,14.7l.007.012A2.525,2.525,0,0,1,16.929,18.5H3.149A2.525,2.525,0,0,1,.99,14.715L1,14.7,7.878,3.217l0,0A2.539,2.539,0,0,1,10.039,2Z",
    transform: "translate(27.5 5.35) rotate(90)",
    fill: "#d2dce9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleLight);
export default __webpack_public_path__ + "static/media/triangleLight.e966ca0d56c5cf3c0bee43f231b9a4b6.svg";
export { ForwardRef as ReactComponent };